import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  content: {
    height: '100%',
  },
  accordion: {
    marginBottom: '32px',
    '@media (max-width: 600px)': {
      marginBottom: '16px',
    },
  },
  downloadButton: {
    minWidth: '156px !important',
  },
  signatureDateText: {
    color: STYLE.COLOR.TEXT2,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    marginTop: 12,
  },
  downloadIcon: {
    marginLeft: '8px',
  },
  // Keeps the chevron on the middle of the summary's FIRST line instead of the
  // vertical centre of a title that wraps onto two or three lines.
  consentFormAccordion: {
    '& .MuiAccordionSummary-root': {
      alignItems: 'flex-start',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      display: 'flex',
      alignItems: 'center',
      height: '28px',
      '@media (max-width: 600px)': {
        height: '24px',
      },
    },
  },
  // Inline flow rather than flex, so the chip sits right after the last word of
  // a wrapping title instead of being pushed onto a line of its own.
  consentFormChip: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    marginLeft: '12px',
  },
  consentFormContent: {
    wordWrap: 'break-word',
  },
  signatureImage: {
    maxWidth: '100%',
    height: '80px',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  loader: {
    position: 'relative',
    top: 'unset',
    left: 'unset',
    transform: 'unset',
  },
  assignedCompaniesContainer: {
    marginBottom: '24px',
  },
}));

export const useStylesAccordionDetails = makeStyles((theme: any) => ({
  accordionDetailsContainer: {
    marginBottom: -6,
  },
  sectionTitle: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT2,
  },
  item: {
    display: 'flex',
    flexDirection: 'column !important' as any,
    wordWrap: 'break-word',
    marginBottom: '6px !important',
  },
  label: {
    color: STYLE.COLOR.TEXT2,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    marginBottom: '12px',
    wordWrap: 'break-word',
  },
  value: {
    color: STYLE.COLOR.TEXT1,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '22px',
  },
  imageUrlsRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  storedFieldImage: {
    width: '148px',
    height: '148px',
    objectFit: 'cover' as any,
    borderRadius: '16px',
    marginBottom: '8px',
    display: 'block',
  },
  sectionSeparator: {
    paddingTop: '32px !important',
    paddingBottom: '16px !important',
    '& hr': {
      margin: 0,
      backgroundColor: STYLE.COLOR.TABS_BORDER,
      height: '1px',
      border: 'none',
    },
  },
}));
